// extracted by mini-css-extract-plugin
export default {"navPages":"Paging_navPages__qZDKd","pageList":"Paging_pageList__gExYV","numberPage":"Paging_numberPage__5DoU3","pageBtn":"Paging_pageBtn__yr+KW","match":"Paging_match__4bUDY"};